import useInitInjectScripts from 'components/ThirdPartyScripts/hooks/useInitInjectScripts';
import BusinessInfoContextProvider from 'contexts/BusinessContextProvider';
import NotificationContextProvider from 'contexts/NotificationContextProvider';
import TrialsContextProvider from 'contexts/TrialsContextProvider';
import useMobileViewport from 'hooks/useMobileViewport';
import TrialsPage from 'components/Trials';

const Trials = () => {
  useInitInjectScripts(true);
  useMobileViewport();

  return (
    <TrialsContextProvider>
      <BusinessInfoContextProvider>
        <NotificationContextProvider>
          <TrialsPage />
        </NotificationContextProvider>
      </BusinessInfoContextProvider>
    </TrialsContextProvider>
  );
};

export default Trials;
